module.exports = __webpack_public_path__ + "static/media/veryvell-group.1a5c2a41.png";